import App from './App.jsx';

export default App;


// WEBPACK FOOTER //
// ./src/components/app/index.js